function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    d: "M14.512 15C7.5 13.552 2.896 9.303 1.5 2.674L5.198 1l2.83 3.568L6.452 6.02c.105.676.96 2.11 1.744 2.833.628.58 2.129 1.32 2.861 1.416l1.574-1.452 3.868 2.61z"
  }));
};
export default SvgCall;